import template from './billing_category.all.html'
import controller from './billing_category.all.controller'
import './billing_category.all.scss'

const billingCategoryAllComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default billingCategoryAllComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/billing_category/all/billing_category.all.component.js